import { render, staticRenderFns } from "./submitTipModal.vue?vue&type=template&id=63378bd0&scoped=true"
import script from "./submitTipModal.vue?vue&type=script&lang=js"
export * from "./submitTipModal.vue?vue&type=script&lang=js"
import style0 from "./submitTipModal.vue?vue&type=style&index=0&id=63378bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63378bd0",
  null
  
)

export default component.exports